import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { getPaginationConfig } from '../../../components/pagination';
import { Table, Button, Modal } from 'antd';
import { QuestionCircleFilled, EditOutlined, DeleteOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';
import FormModal from './FormModal';
const { confirm } = Modal;
const { Column } = Table;
@inject('indexManagementStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    record: null
  }
  componentDidMount() {
  }
  handleEdit = (record) => {
    const { indexManagementStore } = this.props;
    indexManagementStore.onGetAction(record.id).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const { indexManagementStore } = this.props;
    confirm({
      title: 'Delete Data',
      icon: <QuestionCircleFilled />,
      content: 'Are you sure you want to delete it ?',
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk() {
        indexManagementStore.onDeleteAction(record.id);
      },
      onCancel() {
        console.log('Cancel');
      },
    })
    return false;
  }
  handleActive = (record) => {
    const { indexManagementStore } = this.props;
    const params = {
      id: record.id,
      isActive: record.isActive === 0 ? 1 : 0
      // "dataType": record.dataType,
      // "apiName": record.apiName,
      // "fieldInfos": record.fieldInfos,
      // "indexName": record.indexName,
      // "indexPath": record.indexPath,
      // "sampleData": "",
      // "active": record.active===true ? false : true,
    }
    indexManagementStore.onEditAction(params, record.id)
  }
  handlePageChange = (page, pageSize) => {
    const { indexManagementStore } = this.props;
    indexManagementStore.onChangePageNumAction(page, pageSize);
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { indexManagementStore, } = this.props
    const { pageNo, pageSize, itemCount, indexSetList } = indexManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange);
    return (
      <>
        <Table className='searchResult' dataSource={toJS(indexSetList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} bordered>
          <Column width={150} title='Direction' dataIndex="direction" key="direction" />
          <Column title='API Name' dataIndex="apiConfigName" key="apiConfigName" />
          <Column title='Index Name' dataIndex="indexName" key="indexName" />
          <Column title='Index Path' dataIndex="indexPath" key="indexPath" />
          <Column width={150} align='center' title="Action" key="Action" render={(text, record) => (
            <>
              <Button onClick={() => this.handleEdit(record)} type='link' icon={<EditOutlined />} title='Edit' />
              {
                record.isActive === 1 ? (
                  <Button type='link' onClick={() => this.handleActive(record)} icon={<UnlockOutlined />} title='Active' />
                ) : (
                  <Button type='link' className='grey' onClick={() => this.handleActive(record)} icon={<LockOutlined />} title='Inactive' />
                )
              }
              {/* <Button onClick={() => this.handleActive(record)} type='link' icon={record.active? <UnlockOutlined />: <LockOutlined />} title={record.active? "Active": "Inactive" }className={record.active? null: 'grey'} /> */}
              <Button type='link' onClick={() => this.handleDel(record)} icon={<DeleteOutlined />} title='Delete' />
            </>
          )} />
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title='edit'
        /> : null}
      </>
    );
  }
}

export default SearchResult;
